// src/GlobalStyles.js
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export default function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
          margin: 0,
          padding: 0,
        },
        html: {
          scrollBehavior: 'smooth',
        },
        body: {
          backgroundColor: '#f8fffb',
          color: '#132714',
          fontFamily: '"Poppins", "Roboto", sans-serif',
          lineHeight: 1.6,
        },
        '.section': {
          animation: `${fadeIn} 0.6s ease-out forwards`,
        },
        '.hero-title': {
          animation: `${fadeIn} 0.8s ease-out 0.2s both`,
        },
        '.hero-subtitle': {
          animation: `${fadeIn} 0.8s ease-out 0.4s both`,
        },
        '.hero-button': {
          animation: `${fadeIn} 0.8s ease-out 0.6s both, ${pulse} 2s infinite 2s`,
        },
        a: {
          textDecoration: 'none',
          color: 'inherit',
          transition: 'color 0.3s ease',
          '&:hover': {
            color: '#57a649',
          },
        },
        'img': {
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
        },
        '.fade-in': {
          opacity: 0,
          animation: `${fadeIn} 0.6s ease-out forwards`,
        },
      }}
    />
  );
}